import { render, staticRenderFns } from "./FaltantesIndex.vue?vue&type=template&id=9b0c08d8"
import script from "./FaltantesIndex.vue?vue&type=script&lang=js"
export * from "./FaltantesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports